import type React from 'react';
import { useTranslation } from 'react-i18next';
import { formatSettingsDate } from '../format-settings-date';
import { MigrationStateLayout } from './MigrationStateLayout';

interface AwaitingCycleStateProps {
  expectedEffectiveAt: string | null;
  currencyNotice?: string;
}

/**
 * Approved by the merchant; Shopify applies it at the next billing cycle. Green,
 * not orange: the merchant has done their part, only the cycle is left.
 */
export const AwaitingCycleState: React.FC<AwaitingCycleStateProps> = ({
  expectedEffectiveAt,
  currencyNotice,
}) => {
  const { t } = useTranslation();

  return (
    <MigrationStateLayout
      tone="success"
      status={t('settings.subscription.successFeeMigration.awaitingCycle.body')}
      detail={t('settings.subscription.successFeeMigration.awaitingCycle.detail', {
        date: formatSettingsDate(expectedEffectiveAt, t('common.locale')),
      })}
      currencyNotice={currencyNotice}
    />
  );
};
